/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SyncAppIndexRouteImport } from './routes/sync-app/index'
import { Route as SignInIndexRouteImport } from './routes/sign-in/index'
import { Route as PhoneIndexRouteImport } from './routes/phone/index'
import { Route as LogoutIndexRouteImport } from './routes/logout/index'
import { Route as LocationIndexRouteImport } from './routes/location/index'
import { Route as GlobalSettingsIndexRouteImport } from './routes/global-settings/index'
import { Route as FeatureFlagsIndexRouteImport } from './routes/feature-flags/index'
import { Route as SyncAppMultiLocationRouteImport } from './routes/sync-app/multi-location'
import { Route as SignInCallbackRouteImport } from './routes/sign-in/callback'
import { Route as SettingsUsersRouteImport } from './routes/settings/users'
import { Route as SettingsReviewsRouteImport } from './routes/settings/reviews'
import { Route as SettingsPaymentsRouteImport } from './routes/settings/payments'
import { Route as SettingsOnlineSchedulingRouteImport } from './routes/settings/online-scheduling'
import { Route as SettingsManualTemplatesRouteImport } from './routes/settings/manual-templates'
import { Route as SettingsLocationsRouteImport } from './routes/settings/locations'
import { Route as SettingsFeatureFlagsRouteImport } from './routes/settings/feature-flags'
import { Route as SettingsEmailMarketingRouteImport } from './routes/settings/email-marketing'
import { Route as SettingsDesktopClientsRouteImport } from './routes/settings/desktop-clients'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as Settings10DlcRouteImport } from './routes/settings/10-dlc'
import { Route as PhoneVoicemailBoxesRouteImport } from './routes/phone/voicemail-boxes'
import { Route as PhonePhoneTreeRouteImport } from './routes/phone/phone-tree'
import { Route as PhoneOrderNewNumberRouteImport } from './routes/phone/order-new-number'
import { Route as PhoneOfficeHoursRouteImport } from './routes/phone/office-hours'
import { Route as PhoneMediaLibraryRouteImport } from './routes/phone/media-library'
import { Route as PhoneFaxSettingsRouteImport } from './routes/phone/fax-settings'
import { Route as PhoneDevicesRouteImport } from './routes/phone/devices'
import { Route as PhoneCallSettingsRouteImport } from './routes/phone/call-settings'
import { Route as OnboardingPortingRouteImport } from './routes/onboarding/porting'
import { Route as OnboardingOnboardingRouteImport } from './routes/onboarding/onboarding'
import { Route as OnboardingIntakeFormRouteImport } from './routes/onboarding/intake-form'
import { Route as OnboardingHandoffHubRouteImport } from './routes/onboarding/handoff-hub'
import { Route as LoginCallbackRouteImport } from './routes/login/callback'
import { Route as HistoryWritebacksRouteImport } from './routes/history/writebacks'
import { Route as HistorySmsRouteImport } from './routes/history/sms'
import { Route as HistoryRecallEventsRouteImport } from './routes/history/recall-events'
import { Route as HistoryPatientRouteImport } from './routes/history/patient'
import { Route as HistoryOrderEventsRouteImport } from './routes/history/order-events'
import { Route as HistoryLogsRouteImport } from './routes/history/logs'
import { Route as HistoryEmailRouteImport } from './routes/history/email'
import { Route as HistoryClientLocationsRouteImport } from './routes/history/client-locations'
import { Route as HistoryCallRecordsRouteImport } from './routes/history/call-records'
import { Route as HistoryAuditLogsRouteImport } from './routes/history/audit-logs'
import { Route as HistoryAppointmentsRouteImport } from './routes/history/appointments'
import { Route as GlobalSettingsUserLookUpRouteImport } from './routes/global-settings/user-look-up'
import { Route as GlobalSettingsUserConfigRouteImport } from './routes/global-settings/user-config'
import { Route as GlobalSettingsReleasesRouteImport } from './routes/global-settings/releases'
import { Route as GlobalSettingsProvisionLocationsRouteImport } from './routes/global-settings/provision-locations'
import { Route as GlobalSettingsPortabilityCheckRouteImport } from './routes/global-settings/portability-check'
import { Route as GlobalSettingsOutageAlertsRouteImport } from './routes/global-settings/outage-alerts'
import { Route as GlobalSettingsNetworkRouteImport } from './routes/global-settings/network'
import { Route as GlobalSettingsGlobalFeatureFlagsRouteImport } from './routes/global-settings/global-feature-flags'
import { Route as GlobalSettingsGlobalAuditLogsRouteImport } from './routes/global-settings/global-audit-logs'
import { Route as GlobalSettingsFeatureFlagsRouteImport } from './routes/global-settings/feature-flags'
import { Route as GlobalSettingsE911DashboardRouteImport } from './routes/global-settings/e911-dashboard'
import { Route as GlobalSettingsTruelarkCustomerSupportRouteImport } from './routes/global-settings/truelark-configurations'
import { Route as GlobalSettingsDesktopReleasesRouteImport } from './routes/global-settings/desktop-releases'
import { Route as GlobalSettingsDesktopReleasesReleaseIdRouteImport } from './routes/global-settings/desktop-releases_.$releaseId'
import { Route as GlobalSettingsReleasesSiteNameRouteImport } from './routes/global-settings/releases_.$siteName'
import { Route as GlobalSettingsSalesDemoSandboxesRouteImport } from './routes/global-settings/sales-demo-sandboxes'
import { Route as GlobalSettingsSalesDemoSandboxesSandboxIdRouteImport } from './routes/global-settings/sales-demo-sandboxes_.$sandboxId'
import { Route as GlobalSettingsSalesDemoRegistryRouteImport } from './routes/global-settings/sales-demo-registry'
import { Route as GlobalSettingsSalesDemoDagRouteImport } from './routes/global-settings/sales-demo-dag'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncAppIndexRoute = SyncAppIndexRouteImport.update({
  id: '/sync-app/',
  path: '/sync-app/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneIndexRoute = PhoneIndexRouteImport.update({
  id: '/phone/',
  path: '/phone/',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutIndexRoute = LogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationIndexRoute = LocationIndexRouteImport.update({
  id: '/location/',
  path: '/location/',
  getParentRoute: () => rootRouteImport,
} as any)
const GlobalSettingsIndexRoute = GlobalSettingsIndexRouteImport.update({
  id: '/global-settings/',
  path: '/global-settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeatureFlagsIndexRoute = FeatureFlagsIndexRouteImport.update({
  id: '/feature-flags/',
  path: '/feature-flags/',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncAppMultiLocationRoute = SyncAppMultiLocationRouteImport.update({
  id: '/sync-app/multi-location',
  path: '/sync-app/multi-location',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInCallbackRoute = SignInCallbackRouteImport.update({
  id: '/sign-in/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsReviewsRoute = SettingsReviewsRouteImport.update({
  id: '/settings/reviews',
  path: '/settings/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPaymentsRoute = SettingsPaymentsRouteImport.update({
  id: '/settings/payments',
  path: '/settings/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOnlineSchedulingRoute =
  SettingsOnlineSchedulingRouteImport.update({
    id: '/settings/online-scheduling',
    path: '/settings/online-scheduling',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsManualTemplatesRoute = SettingsManualTemplatesRouteImport.update({
  id: '/settings/manual-templates',
  path: '/settings/manual-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/settings/locations',
  path: '/settings/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsFeatureFlagsRoute = SettingsFeatureFlagsRouteImport.update({
  id: '/settings/feature-flags',
  path: '/settings/feature-flags',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEmailMarketingRoute = SettingsEmailMarketingRouteImport.update({
  id: '/settings/email-marketing',
  path: '/settings/email-marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDesktopClientsRoute = SettingsDesktopClientsRouteImport.update({
  id: '/settings/desktop-clients',
  path: '/settings/desktop-clients',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const Settings10DlcRoute = Settings10DlcRouteImport.update({
  id: '/settings/10-dlc',
  path: '/settings/10-dlc',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneVoicemailBoxesRoute = PhoneVoicemailBoxesRouteImport.update({
  id: '/phone/voicemail-boxes',
  path: '/phone/voicemail-boxes',
  getParentRoute: () => rootRouteImport,
} as any)
const PhonePhoneTreeRoute = PhonePhoneTreeRouteImport.update({
  id: '/phone/phone-tree',
  path: '/phone/phone-tree',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneOrderNewNumberRoute = PhoneOrderNewNumberRouteImport.update({
  id: '/phone/order-new-number',
  path: '/phone/order-new-number',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneOfficeHoursRoute = PhoneOfficeHoursRouteImport.update({
  id: '/phone/office-hours',
  path: '/phone/office-hours',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneMediaLibraryRoute = PhoneMediaLibraryRouteImport.update({
  id: '/phone/media-library',
  path: '/phone/media-library',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneFaxSettingsRoute = PhoneFaxSettingsRouteImport.update({
  id: '/phone/fax-settings',
  path: '/phone/fax-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneDevicesRoute = PhoneDevicesRouteImport.update({
  id: '/phone/devices',
  path: '/phone/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoneCallSettingsRoute = PhoneCallSettingsRouteImport.update({
  id: '/phone/call-settings',
  path: '/phone/call-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPortingRoute = OnboardingPortingRouteImport.update({
  id: '/onboarding/porting',
  path: '/onboarding/porting',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingOnboardingRoute = OnboardingOnboardingRouteImport.update({
  id: '/onboarding/onboarding',
  path: '/onboarding/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIntakeFormRoute = OnboardingIntakeFormRouteImport.update({
  id: '/onboarding/intake-form',
  path: '/onboarding/intake-form',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingHandoffHubRoute = OnboardingHandoffHubRouteImport.update({
  id: '/onboarding/handoff-hub',
  path: '/onboarding/handoff-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryWritebacksRoute = HistoryWritebacksRouteImport.update({
  id: '/history/writebacks',
  path: '/history/writebacks',
  getParentRoute: () => rootRouteImport,
} as any)
const HistorySmsRoute = HistorySmsRouteImport.update({
  id: '/history/sms',
  path: '/history/sms',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRecallEventsRoute = HistoryRecallEventsRouteImport.update({
  id: '/history/recall-events',
  path: '/history/recall-events',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryPatientRoute = HistoryPatientRouteImport.update({
  id: '/history/patient',
  path: '/history/patient',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryOrderEventsRoute = HistoryOrderEventsRouteImport.update({
  id: '/history/order-events',
  path: '/history/order-events',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryLogsRoute = HistoryLogsRouteImport.update({
  id: '/history/logs',
  path: '/history/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryEmailRoute = HistoryEmailRouteImport.update({
  id: '/history/email',
  path: '/history/email',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryClientLocationsRoute = HistoryClientLocationsRouteImport.update({
  id: '/history/client-locations',
  path: '/history/client-locations',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryCallRecordsRoute = HistoryCallRecordsRouteImport.update({
  id: '/history/call-records',
  path: '/history/call-records',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryAuditLogsRoute = HistoryAuditLogsRouteImport.update({
  id: '/history/audit-logs',
  path: '/history/audit-logs',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryAppointmentsRoute = HistoryAppointmentsRouteImport.update({
  id: '/history/appointments',
  path: '/history/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const GlobalSettingsUserLookUpRoute =
  GlobalSettingsUserLookUpRouteImport.update({
    id: '/global-settings/user-look-up',
    path: '/global-settings/user-look-up',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsUserConfigRoute =
  GlobalSettingsUserConfigRouteImport.update({
    id: '/global-settings/user-config',
    path: '/global-settings/user-config',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsReleasesRoute = GlobalSettingsReleasesRouteImport.update({
  id: '/global-settings/releases',
  path: '/global-settings/releases',
  getParentRoute: () => rootRouteImport,
} as any)
const GlobalSettingsProvisionLocationsRoute =
  GlobalSettingsProvisionLocationsRouteImport.update({
    id: '/global-settings/provision-locations',
    path: '/global-settings/provision-locations',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsPortabilityCheckRoute =
  GlobalSettingsPortabilityCheckRouteImport.update({
    id: '/global-settings/portability-check',
    path: '/global-settings/portability-check',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsOutageAlertsRoute =
  GlobalSettingsOutageAlertsRouteImport.update({
    id: '/global-settings/outage-alerts',
    path: '/global-settings/outage-alerts',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsNetworkRoute = GlobalSettingsNetworkRouteImport.update({
  id: '/global-settings/network',
  path: '/global-settings/network',
  getParentRoute: () => rootRouteImport,
} as any)
const GlobalSettingsGlobalFeatureFlagsRoute =
  GlobalSettingsGlobalFeatureFlagsRouteImport.update({
    id: '/global-settings/global-feature-flags',
    path: '/global-settings/global-feature-flags',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsGlobalAuditLogsRoute =
  GlobalSettingsGlobalAuditLogsRouteImport.update({
    id: '/global-settings/global-audit-logs',
    path: '/global-settings/global-audit-logs',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsFeatureFlagsRoute =
  GlobalSettingsFeatureFlagsRouteImport.update({
    id: '/global-settings/feature-flags',
    path: '/global-settings/feature-flags',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsE911DashboardRoute =
  GlobalSettingsE911DashboardRouteImport.update({
    id: '/global-settings/e911-dashboard',
    path: '/global-settings/e911-dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsTruelarkCustomerSupportRoute =
  GlobalSettingsTruelarkCustomerSupportRouteImport.update({
    id: '/global-settings/truelark-configurations',
    path: '/global-settings/truelark-configurations',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsDesktopReleasesRoute =
  GlobalSettingsDesktopReleasesRouteImport.update({
    id: '/global-settings/desktop-releases',
    path: '/global-settings/desktop-releases',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsDesktopReleasesReleaseIdRoute =
  GlobalSettingsDesktopReleasesReleaseIdRouteImport.update({
    id: '/global-settings/desktop-releases_/$releaseId',
    path: '/global-settings/desktop-releases/$releaseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsReleasesSiteNameRoute =
  GlobalSettingsReleasesSiteNameRouteImport.update({
    id: '/global-settings/releases_/$siteName',
    path: '/global-settings/releases/$siteName',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsSalesDemoSandboxesRoute =
  GlobalSettingsSalesDemoSandboxesRouteImport.update({
    id: '/global-settings/sales-demo-sandboxes',
    path: '/global-settings/sales-demo-sandboxes',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsSalesDemoSandboxesSandboxIdRoute =
  GlobalSettingsSalesDemoSandboxesSandboxIdRouteImport.update({
    id: '/global-settings/sales-demo-sandboxes_/$sandboxId',
    path: '/global-settings/sales-demo-sandboxes/$sandboxId',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsSalesDemoRegistryRoute =
  GlobalSettingsSalesDemoRegistryRouteImport.update({
    id: '/global-settings/sales-demo-registry',
    path: '/global-settings/sales-demo-registry',
    getParentRoute: () => rootRouteImport,
  } as any)
const GlobalSettingsSalesDemoDagRoute =
  GlobalSettingsSalesDemoDagRouteImport.update({
    id: '/global-settings/sales-demo-dag',
    path: '/global-settings/sales-demo-dag',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/access-denied': typeof AccessDeniedRoute
  '/dashboard': typeof DashboardRoute
  '/global-settings/desktop-releases': typeof GlobalSettingsDesktopReleasesRoute
  '/global-settings/e911-dashboard': typeof GlobalSettingsE911DashboardRoute
  '/global-settings/feature-flags': typeof GlobalSettingsFeatureFlagsRoute
  '/global-settings/global-audit-logs': typeof GlobalSettingsGlobalAuditLogsRoute
  '/global-settings/global-feature-flags': typeof GlobalSettingsGlobalFeatureFlagsRoute
  '/global-settings/network': typeof GlobalSettingsNetworkRoute
  '/global-settings/outage-alerts': typeof GlobalSettingsOutageAlertsRoute
  '/global-settings/portability-check': typeof GlobalSettingsPortabilityCheckRoute
  '/global-settings/provision-locations': typeof GlobalSettingsProvisionLocationsRoute
  '/global-settings/releases': typeof GlobalSettingsReleasesRoute
  '/global-settings/user-config': typeof GlobalSettingsUserConfigRoute
  '/global-settings/user-look-up': typeof GlobalSettingsUserLookUpRoute
  '/history/appointments': typeof HistoryAppointmentsRoute
  '/history/audit-logs': typeof HistoryAuditLogsRoute
  '/history/call-records': typeof HistoryCallRecordsRoute
  '/history/client-locations': typeof HistoryClientLocationsRoute
  '/history/email': typeof HistoryEmailRoute
  '/history/logs': typeof HistoryLogsRoute
  '/history/order-events': typeof HistoryOrderEventsRoute
  '/history/patient': typeof HistoryPatientRoute
  '/history/recall-events': typeof HistoryRecallEventsRoute
  '/history/sms': typeof HistorySmsRoute
  '/history/writebacks': typeof HistoryWritebacksRoute
  '/login/callback': typeof LoginCallbackRoute
  '/onboarding/handoff-hub': typeof OnboardingHandoffHubRoute
  '/onboarding/intake-form': typeof OnboardingIntakeFormRoute
  '/onboarding/onboarding': typeof OnboardingOnboardingRoute
  '/onboarding/porting': typeof OnboardingPortingRoute
  '/phone/call-settings': typeof PhoneCallSettingsRoute
  '/phone/devices': typeof PhoneDevicesRoute
  '/phone/fax-settings': typeof PhoneFaxSettingsRoute
  '/phone/media-library': typeof PhoneMediaLibraryRoute
  '/phone/office-hours': typeof PhoneOfficeHoursRoute
  '/phone/order-new-number': typeof PhoneOrderNewNumberRoute
  '/phone/phone-tree': typeof PhonePhoneTreeRoute
  '/phone/voicemail-boxes': typeof PhoneVoicemailBoxesRoute
  '/settings/10-dlc': typeof Settings10DlcRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/desktop-clients': typeof SettingsDesktopClientsRoute
  '/settings/email-marketing': typeof SettingsEmailMarketingRoute
  '/settings/feature-flags': typeof SettingsFeatureFlagsRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/manual-templates': typeof SettingsManualTemplatesRoute
  '/settings/online-scheduling': typeof SettingsOnlineSchedulingRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/reviews': typeof SettingsReviewsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sync-app/multi-location': typeof SyncAppMultiLocationRoute
  '/feature-flags': typeof FeatureFlagsIndexRoute
  '/global-settings': typeof GlobalSettingsIndexRoute
  '/location': typeof LocationIndexRoute
  '/logout': typeof LogoutIndexRoute
  '/phone': typeof PhoneIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/sync-app': typeof SyncAppIndexRoute
  '/global-settings/releases/$siteName': typeof GlobalSettingsReleasesSiteNameRoute
  '/global-settings/desktop-releases/$releaseId': typeof GlobalSettingsDesktopReleasesReleaseIdRoute
  '/global-settings/sales-demo-sandboxes': typeof GlobalSettingsSalesDemoSandboxesRoute
  '/global-settings/sales-demo-sandboxes/$sandboxId': typeof GlobalSettingsSalesDemoSandboxesSandboxIdRoute
  '/global-settings/sales-demo-registry': typeof GlobalSettingsSalesDemoRegistryRoute
  '/global-settings/sales-demo-dag': typeof GlobalSettingsSalesDemoDagRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/access-denied': typeof AccessDeniedRoute
  '/dashboard': typeof DashboardRoute
  '/global-settings/desktop-releases': typeof GlobalSettingsDesktopReleasesRoute
  '/global-settings/e911-dashboard': typeof GlobalSettingsE911DashboardRoute
  '/global-settings/feature-flags': typeof GlobalSettingsFeatureFlagsRoute
  '/global-settings/global-audit-logs': typeof GlobalSettingsGlobalAuditLogsRoute
  '/global-settings/global-feature-flags': typeof GlobalSettingsGlobalFeatureFlagsRoute
  '/global-settings/network': typeof GlobalSettingsNetworkRoute
  '/global-settings/outage-alerts': typeof GlobalSettingsOutageAlertsRoute
  '/global-settings/portability-check': typeof GlobalSettingsPortabilityCheckRoute
  '/global-settings/provision-locations': typeof GlobalSettingsProvisionLocationsRoute
  '/global-settings/releases': typeof GlobalSettingsReleasesRoute
  '/global-settings/user-config': typeof GlobalSettingsUserConfigRoute
  '/global-settings/truelark-configurations': typeof GlobalSettingsTruelarkCustomerSupportRoute
  '/global-settings/user-look-up': typeof GlobalSettingsUserLookUpRoute
  '/history/appointments': typeof HistoryAppointmentsRoute
  '/history/audit-logs': typeof HistoryAuditLogsRoute
  '/history/call-records': typeof HistoryCallRecordsRoute
  '/history/client-locations': typeof HistoryClientLocationsRoute
  '/history/email': typeof HistoryEmailRoute
  '/history/logs': typeof HistoryLogsRoute
  '/history/order-events': typeof HistoryOrderEventsRoute
  '/history/patient': typeof HistoryPatientRoute
  '/history/recall-events': typeof HistoryRecallEventsRoute
  '/history/sms': typeof HistorySmsRoute
  '/history/writebacks': typeof HistoryWritebacksRoute
  '/login/callback': typeof LoginCallbackRoute
  '/onboarding/handoff-hub': typeof OnboardingHandoffHubRoute
  '/onboarding/intake-form': typeof OnboardingIntakeFormRoute
  '/onboarding/onboarding': typeof OnboardingOnboardingRoute
  '/onboarding/porting': typeof OnboardingPortingRoute
  '/phone/call-settings': typeof PhoneCallSettingsRoute
  '/phone/devices': typeof PhoneDevicesRoute
  '/phone/fax-settings': typeof PhoneFaxSettingsRoute
  '/phone/media-library': typeof PhoneMediaLibraryRoute
  '/phone/office-hours': typeof PhoneOfficeHoursRoute
  '/phone/order-new-number': typeof PhoneOrderNewNumberRoute
  '/phone/phone-tree': typeof PhonePhoneTreeRoute
  '/phone/voicemail-boxes': typeof PhoneVoicemailBoxesRoute
  '/settings/10-dlc': typeof Settings10DlcRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/desktop-clients': typeof SettingsDesktopClientsRoute
  '/settings/email-marketing': typeof SettingsEmailMarketingRoute
  '/settings/feature-flags': typeof SettingsFeatureFlagsRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/manual-templates': typeof SettingsManualTemplatesRoute
  '/settings/online-scheduling': typeof SettingsOnlineSchedulingRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/reviews': typeof SettingsReviewsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sync-app/multi-location': typeof SyncAppMultiLocationRoute
  '/feature-flags': typeof FeatureFlagsIndexRoute
  '/global-settings': typeof GlobalSettingsIndexRoute
  '/location': typeof LocationIndexRoute
  '/logout': typeof LogoutIndexRoute
  '/phone': typeof PhoneIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/sync-app': typeof SyncAppIndexRoute
  '/global-settings/desktop-releases/$releaseId': typeof GlobalSettingsDesktopReleasesReleaseIdRoute
  '/global-settings/releases/$siteName': typeof GlobalSettingsReleasesSiteNameRoute
  '/global-settings/sales-demo-sandboxes': typeof GlobalSettingsSalesDemoSandboxesRoute
  '/global-settings/sales-demo-sandboxes/$sandboxId': typeof GlobalSettingsSalesDemoSandboxesSandboxIdRoute
  '/global-settings/sales-demo-registry': typeof GlobalSettingsSalesDemoRegistryRoute
  '/global-settings/sales-demo-dag': typeof GlobalSettingsSalesDemoDagRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/access-denied': typeof AccessDeniedRoute
  '/dashboard': typeof DashboardRoute
  '/global-settings/desktop-releases': typeof GlobalSettingsDesktopReleasesRoute
  '/global-settings/e911-dashboard': typeof GlobalSettingsE911DashboardRoute
  '/global-settings/feature-flags': typeof GlobalSettingsFeatureFlagsRoute
  '/global-settings/global-audit-logs': typeof GlobalSettingsGlobalAuditLogsRoute
  '/global-settings/global-feature-flags': typeof GlobalSettingsGlobalFeatureFlagsRoute
  '/global-settings/network': typeof GlobalSettingsNetworkRoute
  '/global-settings/outage-alerts': typeof GlobalSettingsOutageAlertsRoute
  '/global-settings/portability-check': typeof GlobalSettingsPortabilityCheckRoute
  '/global-settings/provision-locations': typeof GlobalSettingsProvisionLocationsRoute
  '/global-settings/releases': typeof GlobalSettingsReleasesRoute
  '/global-settings/user-config': typeof GlobalSettingsUserConfigRoute
  '/global-settings/truelark-configurations': typeof GlobalSettingsTruelarkCustomerSupportRoute
  '/global-settings/user-look-up': typeof GlobalSettingsUserLookUpRoute
  '/history/appointments': typeof HistoryAppointmentsRoute
  '/history/audit-logs': typeof HistoryAuditLogsRoute
  '/history/call-records': typeof HistoryCallRecordsRoute
  '/history/client-locations': typeof HistoryClientLocationsRoute
  '/history/email': typeof HistoryEmailRoute
  '/history/logs': typeof HistoryLogsRoute
  '/history/order-events': typeof HistoryOrderEventsRoute
  '/history/patient': typeof HistoryPatientRoute
  '/history/recall-events': typeof HistoryRecallEventsRoute
  '/history/sms': typeof HistorySmsRoute
  '/history/writebacks': typeof HistoryWritebacksRoute
  '/login/callback': typeof LoginCallbackRoute
  '/onboarding/handoff-hub': typeof OnboardingHandoffHubRoute
  '/onboarding/intake-form': typeof OnboardingIntakeFormRoute
  '/onboarding/onboarding': typeof OnboardingOnboardingRoute
  '/onboarding/porting': typeof OnboardingPortingRoute
  '/phone/call-settings': typeof PhoneCallSettingsRoute
  '/phone/devices': typeof PhoneDevicesRoute
  '/phone/fax-settings': typeof PhoneFaxSettingsRoute
  '/phone/media-library': typeof PhoneMediaLibraryRoute
  '/phone/office-hours': typeof PhoneOfficeHoursRoute
  '/phone/order-new-number': typeof PhoneOrderNewNumberRoute
  '/phone/phone-tree': typeof PhonePhoneTreeRoute
  '/phone/voicemail-boxes': typeof PhoneVoicemailBoxesRoute
  '/settings/10-dlc': typeof Settings10DlcRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/desktop-clients': typeof SettingsDesktopClientsRoute
  '/settings/email-marketing': typeof SettingsEmailMarketingRoute
  '/settings/feature-flags': typeof SettingsFeatureFlagsRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/manual-templates': typeof SettingsManualTemplatesRoute
  '/settings/online-scheduling': typeof SettingsOnlineSchedulingRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/reviews': typeof SettingsReviewsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sync-app/multi-location': typeof SyncAppMultiLocationRoute
  '/feature-flags/': typeof FeatureFlagsIndexRoute
  '/global-settings/': typeof GlobalSettingsIndexRoute
  '/location/': typeof LocationIndexRoute
  '/logout/': typeof LogoutIndexRoute
  '/phone/': typeof PhoneIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/sync-app/': typeof SyncAppIndexRoute
  '/global-settings/desktop-releases_/$releaseId': typeof GlobalSettingsDesktopReleasesReleaseIdRoute
  '/global-settings/releases_/$siteName': typeof GlobalSettingsReleasesSiteNameRoute
  '/global-settings/sales-demo-sandboxes': typeof GlobalSettingsSalesDemoSandboxesRoute
  '/global-settings/sales-demo-sandboxes_/$sandboxId': typeof GlobalSettingsSalesDemoSandboxesSandboxIdRoute
  '/global-settings/sales-demo-registry': typeof GlobalSettingsSalesDemoRegistryRoute
  '/global-settings/sales-demo-dag': typeof GlobalSettingsSalesDemoDagRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
  | '/'
  | '/about'
  | '/access-denied'
  | '/dashboard'
  | '/global-settings/desktop-releases'
  | '/global-settings/e911-dashboard'
  | '/global-settings/feature-flags'
  | '/global-settings/global-audit-logs'
  | '/global-settings/global-feature-flags'
  | '/global-settings/network'
  | '/global-settings/outage-alerts'
  | '/global-settings/portability-check'
  | '/global-settings/provision-locations'
  | '/global-settings/releases'
  | '/global-settings/user-config'
  | '/global-settings/truelark-configurations'
  | '/global-settings/user-look-up'
  | '/history/appointments'
  | '/history/audit-logs'
  | '/history/call-records'
  | '/history/client-locations'
  | '/history/email'
  | '/history/logs'
  | '/history/order-events'
  | '/history/patient'
  | '/history/recall-events'
  | '/history/sms'
  | '/history/writebacks'
  | '/login/callback'
  | '/onboarding/handoff-hub'
  | '/onboarding/intake-form'
  | '/onboarding/onboarding'
  | '/onboarding/porting'
  | '/phone/call-settings'
  | '/phone/devices'
  | '/phone/fax-settings'
  | '/phone/media-library'
  | '/phone/office-hours'
  | '/phone/order-new-number'
  | '/phone/phone-tree'
  | '/phone/voicemail-boxes'
  | '/settings/10-dlc'
  | '/settings/billing'
  | '/settings/desktop-clients'
  | '/settings/email-marketing'
  | '/settings/feature-flags'
  | '/settings/locations'
  | '/settings/manual-templates'
  | '/settings/online-scheduling'
  | '/settings/payments'
  | '/settings/reviews'
  | '/settings/users'
  | '/sign-in/callback'
  | '/sync-app/multi-location'
  | '/feature-flags'
  | '/global-settings'
  | '/location'
  | '/logout'
  | '/phone'
  | '/sign-in'
  | '/sync-app'
  | '/global-settings/desktop-releases/$releaseId'
  | '/global-settings/releases/$siteName'
  | '/global-settings/sales-demo-sandboxes'
  | '/global-settings/sales-demo-sandboxes/$sandboxId'
  | '/global-settings/sales-demo-registry'
  | '/global-settings/sales-demo-dag'
  fileRoutesByTo: FileRoutesByTo
  to:
  | '/'
  | '/about'
  | '/access-denied'
  | '/dashboard'
  | '/global-settings/desktop-releases'
  | '/global-settings/e911-dashboard'
  | '/global-settings/feature-flags'
  | '/global-settings/global-audit-logs'
  | '/global-settings/global-feature-flags'
  | '/global-settings/network'
  | '/global-settings/outage-alerts'
  | '/global-settings/portability-check'
  | '/global-settings/provision-locations'
  | '/global-settings/releases'
  | '/global-settings/user-config'
  | '/global-settings/truelark-configurations'
  | '/global-settings/user-look-up'
  | '/history/appointments'
  | '/history/audit-logs'
  | '/history/call-records'
  | '/history/client-locations'
  | '/history/email'
  | '/history/logs'
  | '/history/order-events'
  | '/history/patient'
  | '/history/recall-events'
  | '/history/sms'
  | '/history/writebacks'
  | '/login/callback'
  | '/onboarding/handoff-hub'
  | '/onboarding/intake-form'
  | '/onboarding/onboarding'
  | '/onboarding/porting'
  | '/phone/call-settings'
  | '/phone/devices'
  | '/phone/fax-settings'
  | '/phone/media-library'
  | '/phone/office-hours'
  | '/phone/order-new-number'
  | '/phone/phone-tree'
  | '/phone/voicemail-boxes'
  | '/settings/10-dlc'
  | '/settings/billing'
  | '/settings/desktop-clients'
  | '/settings/email-marketing'
  | '/settings/feature-flags'
  | '/settings/locations'
  | '/settings/manual-templates'
  | '/settings/online-scheduling'
  | '/settings/payments'
  | '/settings/reviews'
  | '/settings/users'
  | '/sign-in/callback'
  | '/sync-app/multi-location'
  | '/feature-flags'
  | '/global-settings'
  | '/location'
  | '/logout'
  | '/phone'
  | '/sign-in'
  | '/sync-app'
  | '/global-settings/desktop-releases/$releaseId'
  | '/global-settings/releases/$siteName'
  | '/global-settings/sales-demo-sandboxes'
  | '/global-settings/sales-demo-sandboxes/$sandboxId'
  | '/global-settings/sales-demo-registry'
  | '/global-settings/sales-demo-dag'
  id:
  | '__root__'
  | '/'
  | '/about'
  | '/access-denied'
  | '/dashboard'
  | '/global-settings/desktop-releases'
  | '/global-settings/e911-dashboard'
  | '/global-settings/feature-flags'
  | '/global-settings/global-audit-logs'
  | '/global-settings/global-feature-flags'
  | '/global-settings/network'
  | '/global-settings/outage-alerts'
  | '/global-settings/portability-check'
  | '/global-settings/provision-locations'
  | '/global-settings/releases'
  | '/global-settings/user-config'
  | '/global-settings/truelark-configurations'
  | '/global-settings/user-look-up'
  | '/history/appointments'
  | '/history/audit-logs'
  | '/history/call-records'
  | '/history/client-locations'
  | '/history/email'
  | '/history/logs'
  | '/history/order-events'
  | '/history/patient'
  | '/history/recall-events'
  | '/history/sms'
  | '/history/writebacks'
  | '/login/callback'
  | '/onboarding/handoff-hub'
  | '/onboarding/intake-form'
  | '/onboarding/onboarding'
  | '/onboarding/porting'
  | '/phone/call-settings'
  | '/phone/devices'
  | '/phone/fax-settings'
  | '/phone/media-library'
  | '/phone/office-hours'
  | '/phone/order-new-number'
  | '/phone/phone-tree'
  | '/phone/voicemail-boxes'
  | '/settings/10-dlc'
  | '/settings/billing'
  | '/settings/desktop-clients'
  | '/settings/email-marketing'
  | '/settings/feature-flags'
  | '/settings/locations'
  | '/settings/manual-templates'
  | '/settings/online-scheduling'
  | '/settings/payments'
  | '/settings/reviews'
  | '/settings/users'
  | '/sign-in/callback'
  | '/sync-app/multi-location'
  | '/feature-flags/'
  | '/global-settings/'
  | '/location/'
  | '/logout/'
  | '/phone/'
  | '/sign-in/'
  | '/sync-app/'
  | '/global-settings/releases_/$siteName'
  | '/global-settings/desktop-releases_/$releaseId'
  | '/global-settings/sales-demo-sandboxes'
  | '/global-settings/sales-demo-sandboxes_/$sandboxId'
  | '/global-settings/sales-demo-registry'
  | '/global-settings/sales-demo-dag'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  DashboardRoute: typeof DashboardRoute
  GlobalSettingsDesktopReleasesRoute: typeof GlobalSettingsDesktopReleasesRoute
  GlobalSettingsE911DashboardRoute: typeof GlobalSettingsE911DashboardRoute
  GlobalSettingsFeatureFlagsRoute: typeof GlobalSettingsFeatureFlagsRoute
  GlobalSettingsGlobalAuditLogsRoute: typeof GlobalSettingsGlobalAuditLogsRoute
  GlobalSettingsGlobalFeatureFlagsRoute: typeof GlobalSettingsGlobalFeatureFlagsRoute
  GlobalSettingsNetworkRoute: typeof GlobalSettingsNetworkRoute
  GlobalSettingsOutageAlertsRoute: typeof GlobalSettingsOutageAlertsRoute
  GlobalSettingsPortabilityCheckRoute: typeof GlobalSettingsPortabilityCheckRoute
  GlobalSettingsProvisionLocationsRoute: typeof GlobalSettingsProvisionLocationsRoute
  GlobalSettingsReleasesRoute: typeof GlobalSettingsReleasesRoute
  GlobalSettingsUserConfigRoute: typeof GlobalSettingsUserConfigRoute
  GlobalSettingsTruelarkCustomerSupportRoute: typeof GlobalSettingsTruelarkCustomerSupportRoute
  GlobalSettingsUserLookUpRoute: typeof GlobalSettingsUserLookUpRoute
  HistoryAppointmentsRoute: typeof HistoryAppointmentsRoute
  HistoryAuditLogsRoute: typeof HistoryAuditLogsRoute
  HistoryCallRecordsRoute: typeof HistoryCallRecordsRoute
  HistoryClientLocationsRoute: typeof HistoryClientLocationsRoute
  HistoryEmailRoute: typeof HistoryEmailRoute
  HistoryLogsRoute: typeof HistoryLogsRoute
  HistoryOrderEventsRoute: typeof HistoryOrderEventsRoute
  HistoryPatientRoute: typeof HistoryPatientRoute
  HistoryRecallEventsRoute: typeof HistoryRecallEventsRoute
  HistorySmsRoute: typeof HistorySmsRoute
  HistoryWritebacksRoute: typeof HistoryWritebacksRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  OnboardingHandoffHubRoute: typeof OnboardingHandoffHubRoute
  OnboardingIntakeFormRoute: typeof OnboardingIntakeFormRoute
  OnboardingOnboardingRoute: typeof OnboardingOnboardingRoute
  OnboardingPortingRoute: typeof OnboardingPortingRoute
  PhoneCallSettingsRoute: typeof PhoneCallSettingsRoute
  PhoneDevicesRoute: typeof PhoneDevicesRoute
  PhoneFaxSettingsRoute: typeof PhoneFaxSettingsRoute
  PhoneMediaLibraryRoute: typeof PhoneMediaLibraryRoute
  PhoneOfficeHoursRoute: typeof PhoneOfficeHoursRoute
  PhoneOrderNewNumberRoute: typeof PhoneOrderNewNumberRoute
  PhonePhoneTreeRoute: typeof PhonePhoneTreeRoute
  PhoneVoicemailBoxesRoute: typeof PhoneVoicemailBoxesRoute
  Settings10DlcRoute: typeof Settings10DlcRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsDesktopClientsRoute: typeof SettingsDesktopClientsRoute
  SettingsEmailMarketingRoute: typeof SettingsEmailMarketingRoute
  SettingsFeatureFlagsRoute: typeof SettingsFeatureFlagsRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsManualTemplatesRoute: typeof SettingsManualTemplatesRoute
  SettingsOnlineSchedulingRoute: typeof SettingsOnlineSchedulingRoute
  SettingsPaymentsRoute: typeof SettingsPaymentsRoute
  SettingsReviewsRoute: typeof SettingsReviewsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SignInCallbackRoute: typeof SignInCallbackRoute
  SyncAppMultiLocationRoute: typeof SyncAppMultiLocationRoute
  FeatureFlagsIndexRoute: typeof FeatureFlagsIndexRoute
  GlobalSettingsIndexRoute: typeof GlobalSettingsIndexRoute
  LocationIndexRoute: typeof LocationIndexRoute
  LogoutIndexRoute: typeof LogoutIndexRoute
  PhoneIndexRoute: typeof PhoneIndexRoute
  SignInIndexRoute: typeof SignInIndexRoute
  SyncAppIndexRoute: typeof SyncAppIndexRoute
  GlobalSettingsReleasesSiteNameRoute: typeof GlobalSettingsReleasesSiteNameRoute
  GlobalSettingsDesktopReleasesReleaseIdRoute: typeof GlobalSettingsDesktopReleasesReleaseIdRoute
  GlobalSettingsSalesDemoSandboxesRoute: typeof GlobalSettingsSalesDemoSandboxesRoute
  GlobalSettingsSalesDemoSandboxesSandboxIdRoute: typeof GlobalSettingsSalesDemoSandboxesSandboxIdRoute
  GlobalSettingsSalesDemoRegistryRoute: typeof GlobalSettingsSalesDemoRegistryRoute
  GlobalSettingsSalesDemoDagRoute: typeof GlobalSettingsSalesDemoDagRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync-app/': {
      id: '/sync-app/'
      path: '/sync-app'
      fullPath: '/sync-app'
      preLoaderRoute: typeof SyncAppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/': {
      id: '/phone/'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof PhoneIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout/': {
      id: '/logout/'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/location/': {
      id: '/location/'
      path: '/location'
      fullPath: '/location'
      preLoaderRoute: typeof LocationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/': {
      id: '/global-settings/'
      path: '/global-settings'
      fullPath: '/global-settings'
      preLoaderRoute: typeof GlobalSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feature-flags/': {
      id: '/feature-flags/'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof FeatureFlagsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync-app/multi-location': {
      id: '/sync-app/multi-location'
      path: '/sync-app/multi-location'
      fullPath: '/sync-app/multi-location'
      preLoaderRoute: typeof SyncAppMultiLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/callback': {
      id: '/sign-in/callback'
      path: '/sign-in/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof SignInCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/reviews': {
      id: '/settings/reviews'
      path: '/settings/reviews'
      fullPath: '/settings/reviews'
      preLoaderRoute: typeof SettingsReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payments': {
      id: '/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof SettingsPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/online-scheduling': {
      id: '/settings/online-scheduling'
      path: '/settings/online-scheduling'
      fullPath: '/settings/online-scheduling'
      preLoaderRoute: typeof SettingsOnlineSchedulingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/manual-templates': {
      id: '/settings/manual-templates'
      path: '/settings/manual-templates'
      fullPath: '/settings/manual-templates'
      preLoaderRoute: typeof SettingsManualTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/settings/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/feature-flags': {
      id: '/settings/feature-flags'
      path: '/settings/feature-flags'
      fullPath: '/settings/feature-flags'
      preLoaderRoute: typeof SettingsFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/email-marketing': {
      id: '/settings/email-marketing'
      path: '/settings/email-marketing'
      fullPath: '/settings/email-marketing'
      preLoaderRoute: typeof SettingsEmailMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/desktop-clients': {
      id: '/settings/desktop-clients'
      path: '/settings/desktop-clients'
      fullPath: '/settings/desktop-clients'
      preLoaderRoute: typeof SettingsDesktopClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/10-dlc': {
      id: '/settings/10-dlc'
      path: '/settings/10-dlc'
      fullPath: '/settings/10-dlc'
      preLoaderRoute: typeof Settings10DlcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/voicemail-boxes': {
      id: '/phone/voicemail-boxes'
      path: '/phone/voicemail-boxes'
      fullPath: '/phone/voicemail-boxes'
      preLoaderRoute: typeof PhoneVoicemailBoxesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/phone-tree': {
      id: '/phone/phone-tree'
      path: '/phone/phone-tree'
      fullPath: '/phone/phone-tree'
      preLoaderRoute: typeof PhonePhoneTreeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/order-new-number': {
      id: '/phone/order-new-number'
      path: '/phone/order-new-number'
      fullPath: '/phone/order-new-number'
      preLoaderRoute: typeof PhoneOrderNewNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/office-hours': {
      id: '/phone/office-hours'
      path: '/phone/office-hours'
      fullPath: '/phone/office-hours'
      preLoaderRoute: typeof PhoneOfficeHoursRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/media-library': {
      id: '/phone/media-library'
      path: '/phone/media-library'
      fullPath: '/phone/media-library'
      preLoaderRoute: typeof PhoneMediaLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/fax-settings': {
      id: '/phone/fax-settings'
      path: '/phone/fax-settings'
      fullPath: '/phone/fax-settings'
      preLoaderRoute: typeof PhoneFaxSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/devices': {
      id: '/phone/devices'
      path: '/phone/devices'
      fullPath: '/phone/devices'
      preLoaderRoute: typeof PhoneDevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phone/call-settings': {
      id: '/phone/call-settings'
      path: '/phone/call-settings'
      fullPath: '/phone/call-settings'
      preLoaderRoute: typeof PhoneCallSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/porting': {
      id: '/onboarding/porting'
      path: '/onboarding/porting'
      fullPath: '/onboarding/porting'
      preLoaderRoute: typeof OnboardingPortingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/onboarding': {
      id: '/onboarding/onboarding'
      path: '/onboarding/onboarding'
      fullPath: '/onboarding/onboarding'
      preLoaderRoute: typeof OnboardingOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/intake-form': {
      id: '/onboarding/intake-form'
      path: '/onboarding/intake-form'
      fullPath: '/onboarding/intake-form'
      preLoaderRoute: typeof OnboardingIntakeFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/handoff-hub': {
      id: '/onboarding/handoff-hub'
      path: '/onboarding/handoff-hub'
      fullPath: '/onboarding/handoff-hub'
      preLoaderRoute: typeof OnboardingHandoffHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/writebacks': {
      id: '/history/writebacks'
      path: '/history/writebacks'
      fullPath: '/history/writebacks'
      preLoaderRoute: typeof HistoryWritebacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/sms': {
      id: '/history/sms'
      path: '/history/sms'
      fullPath: '/history/sms'
      preLoaderRoute: typeof HistorySmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/recall-events': {
      id: '/history/recall-events'
      path: '/history/recall-events'
      fullPath: '/history/recall-events'
      preLoaderRoute: typeof HistoryRecallEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/patient': {
      id: '/history/patient'
      path: '/history/patient'
      fullPath: '/history/patient'
      preLoaderRoute: typeof HistoryPatientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/order-events': {
      id: '/history/order-events'
      path: '/history/order-events'
      fullPath: '/history/order-events'
      preLoaderRoute: typeof HistoryOrderEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/logs': {
      id: '/history/logs'
      path: '/history/logs'
      fullPath: '/history/logs'
      preLoaderRoute: typeof HistoryLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/email': {
      id: '/history/email'
      path: '/history/email'
      fullPath: '/history/email'
      preLoaderRoute: typeof HistoryEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/client-locations': {
      id: '/history/client-locations'
      path: '/history/client-locations'
      fullPath: '/history/client-locations'
      preLoaderRoute: typeof HistoryClientLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/call-records': {
      id: '/history/call-records'
      path: '/history/call-records'
      fullPath: '/history/call-records'
      preLoaderRoute: typeof HistoryCallRecordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/audit-logs': {
      id: '/history/audit-logs'
      path: '/history/audit-logs'
      fullPath: '/history/audit-logs'
      preLoaderRoute: typeof HistoryAuditLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/appointments': {
      id: '/history/appointments'
      path: '/history/appointments'
      fullPath: '/history/appointments'
      preLoaderRoute: typeof HistoryAppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/user-look-up': {
      id: '/global-settings/user-look-up'
      path: '/global-settings/user-look-up'
      fullPath: '/global-settings/user-look-up'
      preLoaderRoute: typeof GlobalSettingsUserLookUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/truelark-configurations': {
      id: '/global-settings/truelark-configurations'
      path: '/global-settings/truelark-configurations'
      fullPath: '/global-settings/truelark-configurations'
      preLoaderRoute: typeof GlobalSettingsTruelarkCustomerSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/user-config': {
      id: '/global-settings/user-config'
      path: '/global-settings/user-config'
      fullPath: '/global-settings/user-config'
      preLoaderRoute: typeof GlobalSettingsUserConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/releases': {
      id: '/global-settings/releases'
      path: '/global-settings/releases'
      fullPath: '/global-settings/releases'
      preLoaderRoute: typeof GlobalSettingsReleasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/provision-locations': {
      id: '/global-settings/provision-locations'
      path: '/global-settings/provision-locations'
      fullPath: '/global-settings/provision-locations'
      preLoaderRoute: typeof GlobalSettingsProvisionLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/portability-check': {
      id: '/global-settings/portability-check'
      path: '/global-settings/portability-check'
      fullPath: '/global-settings/portability-check'
      preLoaderRoute: typeof GlobalSettingsPortabilityCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/outage-alerts': {
      id: '/global-settings/outage-alerts'
      path: '/global-settings/outage-alerts'
      fullPath: '/global-settings/outage-alerts'
      preLoaderRoute: typeof GlobalSettingsOutageAlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/network': {
      id: '/global-settings/network'
      path: '/global-settings/network'
      fullPath: '/global-settings/network'
      preLoaderRoute: typeof GlobalSettingsNetworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/global-feature-flags': {
      id: '/global-settings/global-feature-flags'
      path: '/global-settings/global-feature-flags'
      fullPath: '/global-settings/global-feature-flags'
      preLoaderRoute: typeof GlobalSettingsGlobalFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/global-audit-logs': {
      id: '/global-settings/global-audit-logs'
      path: '/global-settings/global-audit-logs'
      fullPath: '/global-settings/global-audit-logs'
      preLoaderRoute: typeof GlobalSettingsGlobalAuditLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/feature-flags': {
      id: '/global-settings/feature-flags'
      path: '/global-settings/feature-flags'
      fullPath: '/global-settings/feature-flags'
      preLoaderRoute: typeof GlobalSettingsFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/e911-dashboard': {
      id: '/global-settings/e911-dashboard'
      path: '/global-settings/e911-dashboard'
      fullPath: '/global-settings/e911-dashboard'
      preLoaderRoute: typeof GlobalSettingsE911DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/desktop-releases': {
      id: '/global-settings/desktop-releases'
      path: '/global-settings/desktop-releases'
      fullPath: '/global-settings/desktop-releases'
      preLoaderRoute: typeof GlobalSettingsDesktopReleasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/desktop-releases_/$releaseId': {
      id: '/global-settings/desktop-releases_/$releaseId'
      path: '/global-settings/desktop-releases/$releaseId'
      fullPath: '/global-settings/desktop-releases/$releaseId'
      preLoaderRoute: typeof GlobalSettingsDesktopReleasesReleaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/releases_/$siteName': {
      id: '/global-settings/releases_/$siteName'
      path: '/global-settings/releases/$siteName'
      fullPath: '/global-settings/releases/$siteName'
      preLoaderRoute: typeof GlobalSettingsReleasesSiteNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/sales-demo-sandboxes': {
      id: '/global-settings/sales-demo-sandboxes'
      path: '/global-settings/sales-demo-sandboxes'
      fullPath: '/global-settings/sales-demo-sandboxes'
      preLoaderRoute: typeof GlobalSettingsSalesDemoSandboxesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/sales-demo-sandboxes_/$sandboxId': {
      id: '/global-settings/sales-demo-sandboxes_/$sandboxId'
      path: '/global-settings/sales-demo-sandboxes/$sandboxId'
      fullPath: '/global-settings/sales-demo-sandboxes/$sandboxId'
      preLoaderRoute: typeof GlobalSettingsSalesDemoSandboxesSandboxIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/sales-demo-registry': {
      id: '/global-settings/sales-demo-registry'
      path: '/global-settings/sales-demo-registry'
      fullPath: '/global-settings/sales-demo-registry'
      preLoaderRoute: typeof GlobalSettingsSalesDemoRegistryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/global-settings/sales-demo-dag': {
      id: '/global-settings/sales-demo-dag'
      path: '/global-settings/sales-demo-dag'
      fullPath: '/global-settings/sales-demo-dag'
      preLoaderRoute: typeof GlobalSettingsSalesDemoDagRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  DashboardRoute: DashboardRoute,
  GlobalSettingsDesktopReleasesRoute: GlobalSettingsDesktopReleasesRoute,
  GlobalSettingsE911DashboardRoute: GlobalSettingsE911DashboardRoute,
  GlobalSettingsFeatureFlagsRoute: GlobalSettingsFeatureFlagsRoute,
  GlobalSettingsGlobalAuditLogsRoute: GlobalSettingsGlobalAuditLogsRoute,
  GlobalSettingsGlobalFeatureFlagsRoute: GlobalSettingsGlobalFeatureFlagsRoute,
  GlobalSettingsNetworkRoute: GlobalSettingsNetworkRoute,
  GlobalSettingsOutageAlertsRoute: GlobalSettingsOutageAlertsRoute,
  GlobalSettingsPortabilityCheckRoute: GlobalSettingsPortabilityCheckRoute,
  GlobalSettingsProvisionLocationsRoute: GlobalSettingsProvisionLocationsRoute,
  GlobalSettingsReleasesRoute: GlobalSettingsReleasesRoute,
  GlobalSettingsUserConfigRoute: GlobalSettingsUserConfigRoute,
  GlobalSettingsTruelarkCustomerSupportRoute: GlobalSettingsTruelarkCustomerSupportRoute,
  GlobalSettingsUserLookUpRoute: GlobalSettingsUserLookUpRoute,
  HistoryAppointmentsRoute: HistoryAppointmentsRoute,
  HistoryAuditLogsRoute: HistoryAuditLogsRoute,
  HistoryCallRecordsRoute: HistoryCallRecordsRoute,
  HistoryClientLocationsRoute: HistoryClientLocationsRoute,
  HistoryEmailRoute: HistoryEmailRoute,
  HistoryLogsRoute: HistoryLogsRoute,
  HistoryOrderEventsRoute: HistoryOrderEventsRoute,
  HistoryPatientRoute: HistoryPatientRoute,
  HistoryRecallEventsRoute: HistoryRecallEventsRoute,
  HistorySmsRoute: HistorySmsRoute,
  HistoryWritebacksRoute: HistoryWritebacksRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  OnboardingHandoffHubRoute: OnboardingHandoffHubRoute,
  OnboardingIntakeFormRoute: OnboardingIntakeFormRoute,
  OnboardingOnboardingRoute: OnboardingOnboardingRoute,
  OnboardingPortingRoute: OnboardingPortingRoute,
  PhoneCallSettingsRoute: PhoneCallSettingsRoute,
  PhoneDevicesRoute: PhoneDevicesRoute,
  PhoneFaxSettingsRoute: PhoneFaxSettingsRoute,
  PhoneMediaLibraryRoute: PhoneMediaLibraryRoute,
  PhoneOfficeHoursRoute: PhoneOfficeHoursRoute,
  PhoneOrderNewNumberRoute: PhoneOrderNewNumberRoute,
  PhonePhoneTreeRoute: PhonePhoneTreeRoute,
  PhoneVoicemailBoxesRoute: PhoneVoicemailBoxesRoute,
  Settings10DlcRoute: Settings10DlcRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsDesktopClientsRoute: SettingsDesktopClientsRoute,
  SettingsEmailMarketingRoute: SettingsEmailMarketingRoute,
  SettingsFeatureFlagsRoute: SettingsFeatureFlagsRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsManualTemplatesRoute: SettingsManualTemplatesRoute,
  SettingsOnlineSchedulingRoute: SettingsOnlineSchedulingRoute,
  SettingsPaymentsRoute: SettingsPaymentsRoute,
  SettingsReviewsRoute: SettingsReviewsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SignInCallbackRoute: SignInCallbackRoute,
  SyncAppMultiLocationRoute: SyncAppMultiLocationRoute,
  FeatureFlagsIndexRoute: FeatureFlagsIndexRoute,
  GlobalSettingsIndexRoute: GlobalSettingsIndexRoute,
  LocationIndexRoute: LocationIndexRoute,
  LogoutIndexRoute: LogoutIndexRoute,
  PhoneIndexRoute: PhoneIndexRoute,
  SignInIndexRoute: SignInIndexRoute,
  SyncAppIndexRoute: SyncAppIndexRoute,
  GlobalSettingsReleasesSiteNameRoute: GlobalSettingsReleasesSiteNameRoute,
  GlobalSettingsDesktopReleasesReleaseIdRoute: GlobalSettingsDesktopReleasesReleaseIdRoute,
  GlobalSettingsSalesDemoSandboxesRoute: GlobalSettingsSalesDemoSandboxesRoute,
  GlobalSettingsSalesDemoSandboxesSandboxIdRoute: GlobalSettingsSalesDemoSandboxesSandboxIdRoute,
  GlobalSettingsSalesDemoRegistryRoute: GlobalSettingsSalesDemoRegistryRoute,
  GlobalSettingsSalesDemoDagRoute: GlobalSettingsSalesDemoDagRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
